import React from 'react'
import { AbutmentsInfoState, Action } from './types'

export const setAbutmentsInfo = (abutmentsInfo: AbutmentsInfoState) => ({
    type: 'SET_ABUTMENTS_INFO',
    payload: {
        abutmentsInfo,
    },
})

const abutmentsInfoReducer: React.Reducer<AbutmentsInfoState, Action> = (
    state: AbutmentsInfoState,
    action: Action
) => {
    switch (action.type) {
        case 'SET_ABUTMENTS_INFO':
            return {
                ...action.payload.abutmentsInfo,
            }

        default:
            return state
    }
}

export default abutmentsInfoReducer
